import { Dialog, DialogContent, Box, Button, Typography, Stack } from '@mui/material';
import { PointOfSale, Receipt } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

const SelectionDialog = () => {
  const navigate = useNavigate();
  const { modo, setModo, mostrarDialogoSeleccion } = useApp();

  const handleSelectModo = (selectedModo) => {
    setModo(selectedModo);
    // Navegar a la ruta correspondiente según el modo
    if (selectedModo === 'POS') {
      navigate('/pos', { replace: true });
    } else if (selectedModo === 'FACTURACION') {
      navigate('/billing', { replace: true });
    }
  };

  // No mostrar si ya hay un modo seleccionado o el diálogo está deshabilitado
  if (!mostrarDialogoSeleccion || modo) {
    return null;
  }

  return (
    <Dialog 
      open={mostrarDialogoSeleccion} 
      disableEscapeKeyDown
      fullScreen
      PaperProps={{
        sx: {
          maxWidth: 500,
          width: '90%',
          borderRadius: 3,
          p: 2,
          backgroundColor: 'transparent',
          boxShadow: 'none',
        }
      }}
    >
      <DialogContent sx={{ 
        textAlign: 'center', 
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'rgba(25, 25, 35, 0.95)',
        borderRadius: 3,
      }}>
        <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 1 }}>
          FACTURACIÓN ELECTRÓNICA - EL SALVADOR
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Selecciona el módulo con el que deseas trabajar hoy
        </Typography>
        
        <Stack spacing={3} sx={{ mt: 2 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => handleSelectModo('POS')}
            sx={{
              minHeight: 120,
              minWidth: '100%',
              flexDirection: 'column',
              gap: 1,
              backgroundColor: '#2e7d32', // Verde para POS
              '&:hover': {
                backgroundColor: '#1b5e20',
              },
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem',
            }}
          >
            <PointOfSale sx={{ fontSize: 48 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                PUNTO DE VENTA
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                Ventas y transacciones
              </Typography>
            </Box>
          </Button>

          <Button
            variant="contained"
            size="large"
            onClick={() => handleSelectModo('FACTURACION')}
            sx={{
              minHeight: 120,
              minWidth: '100%',
              flexDirection: 'column',
              gap: 1,
              backgroundColor: '#1565c0', // Azul para Facturación
              '&:hover': {
                backgroundColor: '#0d47a1',
              },
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem',
            }}
          >
            <Receipt sx={{ fontSize: 48 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                FACTURACIÓN
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                Emitir facturas y documentos
              </Typography>
            </Box>
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SelectionDialog;
